export const Roles = {
    SUPERADMIN: 0,
    ADMIN: 1,
    USER: 2,
};
